export const generateSlug = (title) => {
    return title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)+/g, '');
};

export const encodeId = (id) => {
    try {
        // Use encodeURIComponent for special characters and btoa for base64
        return btoa(encodeURIComponent(id));
    } catch (error) {
        return id;
    }
};

export const decodeId = (encodedId) => {
    try {
        // Reverse the encoding process
        return decodeURIComponent(atob(encodedId));
    } catch (error) {
        // If decoding fails, try to get the ID from the original string
        const parts = encodedId.split('-');
        return parts[0];
    }
};

export const generateTaleUrl = (tale) => {
    const encodedId = encodeId(tale._id);
    const slug = generateSlug(tale.title);
    return `/tales/${encodedId}-${slug}`;
};

export const extractTaleId = (urlPath) => {
    const encodedPart = urlPath.split('-')[0];
    return decodeId(encodedPart);
}; 